<template lang="html">
  <div id="Map">
  </div>
</template>
<script>
import loadScriptOnce from 'load-script-once'
export default {
  name: 'Map',
  components: {},
  data: () => ({
    map: null
  }),
  mounted() {
    loadScriptOnce(`//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${this.$config.kakao.appKey}&libraries=clusterer`)
      .then(() => {
        kakao.maps.load(() => {
          this.render()
        })
      })
      .catch(err => {
        this.$log.w(err)
      })
  },
  methods: {
    render() {
      var mapContainer = document.getElementById('Map')
      var mapOption = {
        center: new kakao.maps.LatLng(37.532085, 126.914133),
        level: 5
      }

      this.map = new kakao.maps.Map(mapContainer, mapOption)
      this.$event.$emit(this.$eventList.mapLoaded, this.map)
    }
  }
}

</script>
<style lang="scss" scoped>
#Map {}

</style>



// WEBPACK FOOTER //
// src/components/Project/KakaoMap/kakaoMap.vue